export default __webpack_public_path__ + "static/img2_final-9ebef26b15c5dea84b6697095e9732ab.png";